module.exports = __webpack_public_path__ + "img/wc_disabled.598d3ca9.svg";